export const userData = "userData"
export const i18nextLng = "i18nextLng"
export const isDeveloperr = "isDeveloper"
